module.exports = __webpack_public_path__ + "static/img/tubaina.4396bd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/tubaina.png
// module id = aGFe
// module chunks = 0